import { UiName, FieldMap } from "../../shared/types";
import { Lening as AanvraagLeningDlEntry } from "../../.generated/forms/formstypes";
import { target2field } from "../../shared/utils/target-to-field";

export function mapDlTargetToAanvraagLeningUiField(target: string): UiName | null {
  const map: FieldMap<AanvraagLeningDlEntry> = {};

  return target2field(map, target);
}
